import { render } from "./RoomServiceOutline.vue?vue&type=template&id=813d9508"
import script from "./RoomServiceOutline.vue?vue&type=script&lang=js"
export * from "./RoomServiceOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__